/* eslint-disable react-hooks/rules-of-hooks -- false positives from interactivity api */

import { store, getContext } from '@wordpress/interactivity';

import { defineAdSlot } from '../../entrypoints/ads/utils';

const { state, callbacks } = store('mediapress-ads', {
  callbacks: {
    /**
     * Initialize the ad slot
     *
     * Runs the ad slot setup process after gpt is initialized
     */
    init: () => {
      if (!window.googletagInitialized) {
        setTimeout(callbacks.init, 2000);
      } else {
        callbacks.setup();
      }
    },
    /**
     * Setup the ad slot, if it has not already been setup
     *
     * Sets the slot config as context on this item
     *
     * Define the ad slot and display it, if GPT lazyload is
     * active then calling display will not render the ad until it is in view
     */
    setup: () => {
      const context = getContext();
      const { gptSlots } = state;

      context.slotConfig = gptSlots[context.id];

      window.googletag.cmd.push(() => {
        callbacks.define();
        callbacks.display();
      });
    },
    /**
     * Define the ad slot, if it has not already been defined
     */
    define: () => {
      if (!window.googletag) {
        return;
      }

      const context = getContext();
      const { uniqueId, id } = context;

      if (window.mediaPressAdsSlots?.[uniqueId]) {
        return;
      }

      window.googletag.cmd.push(() => {
        defineAdSlot(uniqueId, context.slotConfig, id);
      });
    },
    /**
     * Display the ad
     */
    display: () => {
      const context = getContext();
      const { uniqueId } = context;

      if (context.displayed) {
        return;
      }

      if (!window.mediaPressAdsSlots[uniqueId]) {
        // eslint-disable-next-line no-console -- we need to log this
        console.error('Cannot display ad slot', uniqueId, 'because it has not been defined');
        return;
      }

      window.googletag.cmd.push(() => {
        window.googletag.pubads().refresh([window.mediaPressAdsSlots[uniqueId]]);
        context.displayed = true;
      });
    },
  },
});
